var exports = {
  "kL": "Toasts.module__container___alhvNX",
  "Kd": "Toasts.module__containerMobile___alhvNX",
  "QX": "Toasts.module__containerDesktop___alhvNX",
  "T_": "Toasts.module__toastWrapper___alhvNX",
};

module.exports = exports;
